export default __webpack_public_path__ + "static/media/portadavideoconfiguracion4.eebd5bd0.png";